export default __webpack_public_path__ + "content/media/20.f9c81786.jpg";